angular.module('portal.countries').provider('ShareCrfCountries', function() {
    var countries = {};

    this.setCountries = function(data) {
        countries = data;
    };

    this.$get = [
        'ShareCrfDefaultCountries',
        'ShareCrfLanguageService',
        'gettextCatalog',
        function(ShareCrfDefaultCountries, ShareCrfLanguageService, gettextCatalog) {
            if (Object.keys(countries).length == 0) {
                countries = ShareCrfDefaultCountries;
            }

            return {
                getName: function(abbr) {
                    var lang = ShareCrfLanguageService.getLanguage();

                    return countries[lang.code][abbr.toUpperCase()] || false;
                },
                getOptions: function(includeEmpty) {
                    var options = [];

                    if (includeEmpty) {
                        options.push({
                            id: '',
                            label: '- ' + gettextCatalog.getString('País') + ' -',
                        });
                    }

                    var lang = ShareCrfLanguageService.getLanguage();

                    for (var countryAbbr in countries[lang.code]) {
                        options.push({
                            id: countryAbbr,
                            label: countries[lang.code][countryAbbr],
                        });
                    }

                    return options;
                },
            };
        },
    ];
});
